import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "form-icon"
}
const _hoisted_2 = ["data-icon"]
const _hoisted_3 = {
  key: 1,
  class: "validation-icon is-success"
}
const _hoisted_4 = {
  key: 2,
  class: "validation-icon is-error"
}

import { computed } from 'vue'

export interface VControlProps {
  icon?: string
  isValid?: boolean
  hasError?: boolean
  loading?: boolean
  expanded?: boolean
  textaddon?: boolean
  nogrow?: boolean
  subcontrol?: boolean
}

const name='VControl'

export default /*@__PURE__*/_defineComponent({
  __name: 'VControl',
  props: {
    icon: { default: undefined },
    isValid: { type: Boolean },
    hasError: { type: Boolean },
    loading: { type: Boolean },
    expanded: { type: Boolean },
    textaddon: { type: Boolean },
    nogrow: { type: Boolean },
    subcontrol: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

const isIconify = computed(() => {
  return props.icon && props.icon.indexOf(':') !== -1
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["control", [
      _ctx.icon && 'has-icon',
      _ctx.loading && 'is-loading',
      _ctx.expanded && 'is-expanded',
      _ctx.nogrow && 'is-nogrow',
      _ctx.textaddon && 'is-textarea-addon',
      _ctx.isValid && 'has-validation has-success',
      _ctx.hasError && 'has-validation has-error',
      _ctx.subcontrol && 'subcontrol',
    ]])
  }, [
    _renderSlot(_ctx.$slots, "default"),
    (_ctx.icon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (isIconify.value)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                "aria-hidden": "true",
                class: "iconify",
                "data-icon": _ctx.icon
              }, null, 8, _hoisted_2))
            : (_openBlock(), _createElementBlock("i", {
                key: 1,
                "aria-hidden": "true",
                class: _normalizeClass(_ctx.icon)
              }, null, 2))
        ]))
      : _createCommentVNode("", true),
    (_ctx.isValid)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("i", {
            "aria-hidden": "true",
            class: "iconify",
            "data-icon": "feather:check"
          }, null, -1)
        ]))]))
      : (_ctx.hasError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("i", {
              "aria-hidden": "true",
              class: "iconify",
              "data-icon": "feather:x"
            }, null, -1)
          ]))]))
        : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "extra")
  ], 2))
}
}

})